namespace $ { export class $mol_list extends $mol_view {

	/// sub <= rows -
	sub() {
		return this.rows()
	}

	/// rows /
	rows() {
		return [] as any[]
	}

	/// Empty null
	Empty() {
		return null as any
	}

} }

